import React from 'react';
import { Modal, Space } from 'antd';
import MainButton from 'components/MainButton/MainButton';

const ModalConfirm: React.FC<{
  open: boolean;
  onClose: () => void;
  handleConfirm: () => void;
  title: string;
  subTitle: string;
}> = ({ open, onClose, handleConfirm, title, subTitle }) => (
  <Modal
    title={title}
    centered
    open={open}
    onCancel={onClose}
    footer={[
      <Space align="center" key="actions">
        <MainButton subButton text="いいえ" onClick={onClose} />
        <MainButton
          text="はい"
          onClick={() => {
            handleConfirm();
            onClose();
          }}
        />
      </Space>,
    ]}
    destroyOnClose
  >
    <p>{subTitle}</p>
  </Modal>
);

export default ModalConfirm;
